import * as React from 'react';
const SvgInstagram = (props) => (
    <svg
        xmlns='http://www.w3.org/2000/svg'
        width={20}
        height={20}
        fill='none'
        {...props}>
        <g fill='currentColor'>
            <path d='M10 7.643A2.367 2.367 0 0 1 12.357 10 2.36 2.36 0 0 1 10 12.357 2.36 2.36 0 0 1 7.643 10 2.36 2.36 0 0 1 10 7.643m-3.297 2.851.027.161zl-.02-.164q.008.083.02.163M13.334 10l-.004.167q.004-.083.004-.167' />
            <path
                fillRule='evenodd'
                d='M14.4 3.333c1.215 0 2.208.994 2.208 2.21v8.8a2.21 2.21 0 0 1-2.209 2.209H5.6a2.215 2.215 0 0 1-2.21-2.21V5.544c0-1.216.995-2.21 2.21-2.21zM10 6.4a3.58 3.58 0 0 0-2.546 1.054A3.58 3.58 0 0 0 6.4 10a3.58 3.58 0 0 0 1.054 2.546A3.58 3.58 0 0 0 10 13.6c.962 0 1.862-.376 2.546-1.054A3.58 3.58 0 0 0 13.6 10c0-.961-.376-1.867-1.055-2.546A3.58 3.58 0 0 0 10 6.4m4-1.067a.667.667 0 1 0 .001 1.333A.667.667 0 0 0 14 5.333'
                clipRule='evenodd'
            />
        </g>
    </svg>
);
export default SvgInstagram;
